import axios from 'axios';
import { getAuthHeader } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
    baseURL: API_URL,
    headers: getAuthHeader()
});

const adminApi = {
    // Asset endpoints
    getAssets: () => {
        return api.get('/api/admin/assets');
    },

    getAsset: (id: string) => {
        return api.get(`/api/admin/assets/${id}`);
    },

    uploadAsset: (formData: FormData) => {
        return api.post('/api/admin/assets/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    deleteAsset: (id: string) => {
        return api.delete(`/api/admin/assets/${id}`);
    },

    // Settings endpoints
    getBrandingSettings: () => api.get('/api/admin/settings/branding'),
    updateBrandingSettings: (data: any) => api.put('/api/admin/settings/branding', data),
    uploadLogo: (formData: FormData) => api.post('/api/admin/settings/branding/logo', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }),
    uploadCouponLogo: (formData: FormData) => api.post('/api/admin/coupons/logo', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }),
};

export default adminApi;
